export enum ReportItemGroupType {
  MACHINE = 'MACHINE',
  GROUP = 'GROUP'
}
